import React, { forwardRef } from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import ListContext from '../List/ListContext';
import styles from './ListItemIcon.module.css';

const ListItemIcon = forwardRef(function ListItemIcon(props, ref) {
  const { className, ...other } = props;
  const context = React.useContext(ListContext);

  return (
    <div
      className={cn(
        styles.root,
        {
          [styles.alignItemsFlexStart]: context.alignItems === 'flex-start',
        },
        className,
      )}
      ref={ref}
      {...other}
    />
  );
});

/* eslint-disable */
ListItemIcon.propTypes = {
  children: Type.node,
  className: Type.string,
};
/* eslint-enable */

export default ListItemIcon;
